import { useParams, useLocation } from 'react-router-dom';
import { useReport } from '../../../../api/hooks/useReport';
import useElementMarketMaker from '../../../../api/hooks/useElementMarketMaker';
import BannerMarketMaker from '../../../../components/report/listaDriverPage/market-maker/BannerMarketMaker';
import ContainerMarketMaker from '../../../../components/report/listaDriverPage/market-maker/ContainerMarketMaker';
import DownloadReportButton from '../../../../components/report/listaDriverPage/DownloadReportButton';

const MarketMakerPage = () => {
    const { name, driverRoute } = useParams<{ name: string; driverRoute: string }>();
    const location = useLocation();
    const { id, driverId } = location.state || {};
    const { report, loading: loadingReport, error: errorReport } = useReport(id);
    const { elements: intermediari, loading: loadingElements, error: errorElements } = useElementMarketMaker(id, driverId);
    if (loadingReport || loadingElements) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
            </div>
        );
    }

    if (errorReport || errorElements) {
        return <div className="text-red-600">{errorReport || errorElements}</div>;
    }

    return (
        <div className="flex flex-col bg-gray-50">
            <BannerMarketMaker report={report} title={driverRoute!} reportId={id} />
            <div className="px-8 lg:px-16 py-8">
                <div className="flex justify-end mb-4">
                    <DownloadReportButton reportId={id} componentId={driverId} />
                </div>
                <ContainerMarketMaker
                    reportId={name!}
                    intermediari={intermediari}
                    driverRoute={driverRoute!}
                    idReport={id}
                    driverId={driverId}
                />
            </div>
        </div>
    )
}

export default MarketMakerPage